var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.9999 44.9942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a404e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deelo-icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.6554,41.0566H6.53a2.5936,2.5936,0,0,1-2.5922-2.5924V6.53A2.5936,2.5936,0,0,1,6.53,3.9375h9.1254a1.9688,1.9688,0,0,0,0-3.9375H6.53A6.5375,6.5375,0,0,0,0,6.53V38.4642a6.5375,6.5375,0,0,0,6.53,6.53h9.1254a1.9688,1.9688,0,0,0,0-3.9375Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.8432,23.2616a1.9323,1.9323,0,0,0,0-1.5244,1.9117,1.9117,0,0,0-.19-.2847,1.9486,1.9486,0,0,0-.23-.3463L33.0163,9.6988a1.969,1.969,0,0,0-2.7847,2.7846h0L38.28,20.53H15.6554a1.9688,1.9688,0,1,0-.028,3.9375H38.28l-8.0483,8.0434a1.969,1.969,0,0,0,2.7847,2.7846h0L44.4237,23.8908a1.972,1.972,0,0,0,.2669-.4A1.9354,1.9354,0,0,0,44.8432,23.2616Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c55faa0d0e1e94828364368e0d1234a5.svg";
export { ForwardRef as ReactComponent };